import { defineComponent as _defineComponent } from 'vue'
import useTooltip from './composables/useTooltip'


export default /*#__PURE__*/_defineComponent({
  __name: 'LFCustomTooltipComponent',
  setup(__props) {

const { tooltipMessage } = useTooltip()

return { __sfc: true,tooltipMessage }
}

})